const mock = [
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Advance Fast Card Rs 10 ',
    id: '45',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1998,
        bookedInventory: 50,
        marginPercent: 12.5,
        mrp: 10,
        price: 8.75,
        vat: 14.5,
        warehouseId: '1',
        warehouseName: 'Cloud Dealers Pvt Ltd',
        discountPercent: 10,
        secondaryDiscountPercent: 5,
        __typename: 'Inventory',
      },
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1998,
        bookedInventory: 0,
        cutOffTime: '20:00:00',
        marginPercent: 20.0,
        mrp: 10,
        price: 8,
        vat: 14.5,
        warehouseId: '2',
        warehouseName: 'Venkateshwara Sellers',
        discountPercent: 0,
        secondaryDiscountPercent: 0,
        __typename: 'Inventory',
      },
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 0,
        bookedInventory: 0,
        cutOffTime: '16:00:00',
        marginPercent: 30.0,
        mrp: 10,
        price: 7,
        vat: 14.5,
        warehouseId: '3',
        warehouseName: 'Fast Track Dealer',
        discountPercent: 5,
        secondaryDiscountPercent: 2,
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Good Knight  Advance Fast Card, Rs.10/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/GoodKnightAdvanceFastCardRs.10150995232786641509952327.png',
    price: 8.75,
    schemesForOutlet: [],
    size: '',
    status: 'INACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Silver PowerLite 45N Combo Rs 72 ',
    id: '46',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 10.416667,
        cutOffTime: '01:04:00',
        mrp: 72,
        price: 64.5,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
        discountPercent: 10,
        secondaryDiscountPercent: 0,
      },
    ],
    mrp: 72,
    name: 'Good Knight Silver PowerLite 45N Combo, Rs.72/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/good20nite-750x750155739938241391557399382.png',
    price: 64.5,
    schemesForOutlet: [
      {
        id: '2',
        name: 'Buy 1 get 1 free',
        __typename: 'schemesForOutlet',
      },
      {
        id: '4',
        name: 'Extra 10% off',
        __typename: 'schemesForOutlet',
      },
      {
        id: '5',
        name: 'Extra 20% off',
        __typename: 'schemesForOutlet',
      },
      {
        id: '6',
        name: 'Extra 30% off',
        __typename: 'schemesForOutlet',
      },
    ],
    size: '',
    status: 'INACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Silver Refill 60N Rs 72 ',
    id: '47',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 10.416667,
        mrp: 72,
        price: 64.5,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 0,
        secondaryDiscountPercent: 5,
        __typename: 'Inventory',
      },
    ],
    mrp: 72,
    name: 'Good Knight Silver Refill 60N, Rs.72/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/GoodKnightSilverRefill60N150995256524831509952565.png',
    price: 64.5,
    schemesForOutlet: [],
    size: '',
    status: 'INACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Silver PowerMat Rs 54 ',
    id: '48',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 10,
        mrp: 54,
        price: 48.6,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 0,
        secondaryDiscountPercent: 0,
        __typename: 'Inventory',
      },
    ],
    mrp: 60,
    name: 'Good Knight Silver PowerMat, Rs.60/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/GoodKnightSilverPowerMatRs.54150995224771531509952247.png',
    price: 58.09,
    schemesForOutlet: [],
    size: '',
    status: 'ACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Active Combo Pack Rs 85 ',
    id: '49',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 9.411765,
        mrp: 85,
        price: 77,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 10,
        secondaryDiscountPercent: 0,
        __typename: 'Inventory',
      },
    ],
    mrp: 78,
    name: 'Good Knight Active+ Combo Pack, Rs.85/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/51Ea8h0KbL._SX466_151012021760171510120217.png',
    price: 68.1,
    schemesForOutlet: [],
    size: '',
    status: 'ACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Advance Regular Liquid Rs 72 ',
    id: '50',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 10.416667,
        mrp: 72,
        price: 64.5,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 10,
        secondaryDiscountPercent: 5,
        __typename: 'Inventory',
      },
    ],
    mrp: 72,
    name: 'Good Knight Advance Regular Liquid, Rs.72/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/GOODNIGHT-ADVANCE-600x600151012015219061510120152.png',
    price: 64.5,
    schemesForOutlet: [],
    size: '',
    status: 'ACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Active Shrink Lav 45N Rs 72 ',
    id: '52',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 10.416667,
        mrp: 72,
        price: 64.5,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 10,
        secondaryDiscountPercent: 5,
        __typename: 'Inventory',
      },
    ],
    mrp: 72,
    name: 'Good Knight Active+ Shrink Lav 45N, Rs.72/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/good_knight_advanced_lvender_catridge151020750017111510207500.png',
    price: 64.5,
    schemesForOutlet: [],
    size: '',
    status: 'ACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight 30N Combo Pack Rs 49 ',
    id: '53',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 10.918367,
        mrp: 49,
        price: 43.65,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 10,
        secondaryDiscountPercent: 5,
        __typename: 'Inventory',
      },
    ],
    mrp: 49,
    name: 'Good Knight 30N Combo Pack, Rs.49/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/good-knight-advanced-activ-cartridge-45ml151020756037521510207560.png',
    price: 43.65,
    schemesForOutlet: [],
    size: '',
    status: 'ACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Care Maha Rs 32 ',
    id: '70',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1100,
        marginPercent: 9.090909,
        mrp: 33,
        price: 30,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 10,
        secondaryDiscountPercent: 5,
        __typename: 'Inventory',
      },
    ],
    mrp: 33,
    name: 'Good Knight Care Maha, Rs.33/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/good-knight-maha-jumbo-coil-600x600151011979360391510119793.png',
    price: 30,
    schemesForOutlet: [],
    size: '',
    status: 'ACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470041',
    description: 'Good Knight Care Jumbo Bulk Coil Rs 110 ',
    id: '71',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 11.666667,
        mrp: 120,
        price: 106,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 10,
        secondaryDiscountPercent: 5,
        __typename: 'Inventory',
      },
    ],
    mrp: 120,
    name: 'Good Knight Care Jumbo Bulk Coil, Rs.120/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/51mEknqqNrL155395399383601553953993.png',
    price: 106,
    schemesForOutlet: [],
    size: '',
    status: 'ACTIVE',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Gems 21 36gm Rs 10 ',
    id: '14',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1987,
        marginPercent: 9.1,
        mrp: 10,
        price: 9.09,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        discountPercent: 10,
        secondaryDiscountPercent: 5,
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Cadbury Gems 21.36gm, Rs.10/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/14697875760151021785686211510217856.png',
    price: 9.09,
    schemesForOutlet: [
      {
        id: '2',
        name: 'Buy 1 get 1 free',
        __typename: 'schemesForOutlet',
      },
      {
        id: '4',
        name: 'Extra 10% off',
        __typename: 'schemesForOutlet',
      },
      {
        id: '5',
        name: 'Extra 20% off',
        __typename: 'schemesForOutlet',
      },
      {
        id: '6',
        name: 'Extra 30% off',
        __typename: 'schemesForOutlet',
      },
    ],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Gems 27 8gm Rs 20 ',
    id: '15',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1994,
        marginPercent: 10.5,
        mrp: 20,
        price: 17.9,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 20,
    name: 'Cadbury Gems 27.8gm, Rs.20/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/CADBURY-GEMS-BOX-11083_2151021775386391510217753.png',
    price: 17.9,
    schemesForOutlet: [
      {
        id: '12',
        name: 'Buy 2 get free with 5% and 5 OFF',
        __typename: 'schemesForOutlet',
      },
      {
        id: '13',
        name: 'Extra 10% off',
        __typename: 'schemesForOutlet',
      },
    ],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Dairy Milk Fruit amp amp Nut 38gm Rs 45 ',
    id: '18',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 10.725,
        mrp: 40,
        price: 35.71,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 40,
    name: 'Cadbury Dairy Milk Fruit &amp; Nut 38gm, Rs.40/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Cadbury-Dairy-Milk-Silk-Fruit-And-Nut-55Gm151021811222521510218112.png',
    price: 35.71,
    schemesForOutlet: [
      {
        id: '10',
        name: 'Extra 10% off',
        __typename: 'schemesForOutlet',
      },
    ],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Dairy Milk Roast  Almond 38gm Rs 45 ',
    id: '19',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 10,
        mrp: 40,
        price: 36,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 45,
    name: 'Cadbury Dairy Milk Roast & Almond 38gm, Rs.45/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Cadbury__Dairy_Milk_Roast_Almond_38gm__Chocolate_15009632541798624032151426943213481514269432.png',
    price: 40.27,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Oreo Vanilla 50gm Rs 10 ',
    id: '192',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 9.1,
        mrp: 10,
        price: 9.09,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Cadbury Oreo Vanilla 50gm, Rs.10/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Oreo-Vanilla-Creme-Biscuits-150-gm151021746191271510217461.png',
    price: 9.09,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Dairy Milk Silk Plain Pouch 60gm Rs 70 ',
    id: '553',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 0,
        marginPercent: 12.142858,
        mrp: 70,
        price: 61.5,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 70,
    name: 'Cadbury Dairy Milk Silk Plain Pouch 60gm, Rs.70/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/cadbury_edited/cadbury-dairy-milk-silk-60gm-pouch.png',
    price: 61.5,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Dairy Milk Silk Fruit amp Nut Pouch 55gm Rs 70 ',
    id: '558',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 0,
        marginPercent: 12.142858,
        mrp: 70,
        price: 61.5,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 70,
    name: 'Cadbury Dairy Milk Silk Fruit &amp; Nut Pouch 55gm, Rs.70/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/cadbury_edited/cadbury-dairy-milk-silk-fruit-nut-55gm-pouch.png',
    price: 61.5,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Dairy Milk Silk Roast Almond 55gm Rs 65 ',
    id: '560',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 0,
        marginPercent: 10,
        mrp: 65,
        price: 58.5,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 70,
    name: 'Cadbury Dairy Milk Silk Roast Almond 55gm, Rs.65/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/cadbury_edited/cadbury-dairy-milk-silk-roast-almond-55gm.png',
    price: 61.45,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Cadbury Gems 10 68gm Rs 5 ',
    id: '564',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 0,
        marginPercent: 9,
        mrp: 5,
        price: 4.55,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 5,
    name: 'Cadbury Gems 10.68gm, Rs. 5/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/cadbury_edited/cadbury-gems-sugar-coated-chocolate-23.png',
    price: 4.55,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470041',
    description: 'Bournvita Shakti Clinical Pouch 75gm Rs 30 ',
    id: '2493',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 2000,
        marginPercent: 8.166667,
        mrp: 30,
        price: 27.55,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 30,
    name: 'Bournvita Shakti Clinical Pouch 75gm, Rs.30/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Vikash/product%20image/Cadbury%20image/BOURNVITA-SHAKTI-CLINICAL-75G-POUCH-min.png',
    price: 27.55,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Easy Wash 200gm Rs 25 ',
    id: '28',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 7.826087,
        mrp: 23,
        price: 21.2,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 23,
    name: 'Surf Excel Easy Wash 200gm, Rs.23/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/SURF-XL-EASY-WASH-1.5KG2151178214058491511782140.png',
    price: 21.2,
    schemesForOutlet: [
      {
        id: '1',
        name: 'Buy 1 get another',
        __typename: 'schemesForOutlet',
      },
    ],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Matic Front Load powder 500gm Rs 115 ',
    id: '57',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 6.488,
        mrp: 125,
        price: 116.89,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 122,
    name: 'Surf Excel Matic Front Load powder 500gm, Rs 125/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/290383_13-surf-excel-excel-matic-front-load-detergent-powder151005165781281510051657.png',
    price: 113.1,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Matic Top Load powder 1kg Rs 222 ',
    id: '58',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 10,
        mrp: 205,
        price: 184.5,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 222,
    name: 'Surf Excel Matic Top Load powder 1kg, Rs 222/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/surf-excel-matic-top-load-1kg-detergent151005168638321510051686.png',
    price: 208,
    schemesForOutlet: [
      {
        id: '20',
        name: 'get 5% off',
      },
      {
        id: '20',
        name: 'get 5% off',
      },
      {
        id: '20',
        name: 'get 5% off',
      },
    ],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Matic Top Load powder 500gm Rs 105  ',
    id: '59',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 6.482143,
        mrp: 112,
        price: 104.74,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 110,
    name: 'Surf Excel Matic Top Load powder 500gm, Rs 112/- ',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/1336470412-Z-79-copy151005167422791510051674.png',
    price: 102.1,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel QW powder 60gm Rs 10 ',
    id: '2724',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 11.606,
        mrp: 10,
        price: 8.8394,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Surf Excel QW powder 60gm, Rs.10/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/deep/SKU%20Images/New/Surf/SURF%20excel%20QW%20powder%20%2060g.png',
    price: 8.84,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Powder 12gm Rs 2 ',
    id: '2958',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 13.5,
        mrp: 2,
        price: 1.73,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 2,
    name: 'Surf Excel Powder 12gm, Rs.2/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/deep/SKU%20Images/New/Surf/Surf%20Excel%20Powder%2012gm.png',
    price: 1.73,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Bar 90gm Rs 10 ',
    id: '3046',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 7.4,
        mrp: 10,
        price: 9.26,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Surf Excel Bar 90gm,Rs.10/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Vikash/product%20image/mix%20image/Surf-Excel-Bar-90gm-min.png',
    price: 9.26,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Easy Wash 500gm Rs 54 ',
    id: '3094',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 10.35,
        mrp: 60,
        price: 53.79,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 60,
    name: 'Surf Excel Easy Wash 500gm, Rs.60/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Vikash/product%20image/mix%20image/Surf-excel-easy-wash-min.png',
    price: 53.5,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Easy Wash Powder 1kg Rs 112  ',
    id: '3103',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 7.125,
        mrp: 120,
        price: 111.45,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 129,
    name: 'Surf Excel Easy Wash Powder 1kg, Rs.120/- ',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/surfexcel1kg150996283466681509962834.png',
    price: 111.45,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '2',
    companyId: '470042',
    description: 'Surf Excel Bar 250gm Rs 26 ',
    id: '3160',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 6,
        marginPercent: 8.92,
        mrp: 25,
        price: 22.77,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 25,
    name: 'Surf Excel Bar 250gm, Rs.25/-',
    pictureUrl:
      'https://s3-ap-southeast-1.amazonaws.com/bizompictures/113264_o9pf6_w15100517531551510051753.png',
    price: 22.77,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Bourbon 60gm Rs 10 ',
    id: '239',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 9.087,
        mrp: 10,
        price: 9.0913,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Bourbon 60gm, Rs 10/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/bourbon_10rs.png',
    price: 9.1,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Good Day Butter 83gm 26 Extra  Rs 10 ',
    id: '243',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 10.1,
        mrp: 10,
        price: 8.99,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Good Day Butter 83gm(26%Extra), Rs.10/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/good_day_rich_butter_10rs.png',
    price: 9.09,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Good Day Butter 39gm Rs 5 ',
    id: '245',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 8.2,
        mrp: 5,
        price: 4.59,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 5,
    name: 'Good Day Butter 39gm, Rs.5/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/good_day_rich_butter_5rs.png',
    price: 4.55,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Good Day Cashew 120gm Rs 20 ',
    id: '246',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 9.5,
        mrp: 20,
        price: 18.1,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 20,
    name: 'Good Day Cashew 120gm, Rs.20/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/good_day_cashew_cookies_20rs.png',
    price: 18.25,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Good Day Cashew 58gm Rs 10 ',
    id: '248',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 9.087,
        mrp: 10,
        price: 9.0913,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Good Day Cashew 58gm, Rs.10/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/good_day_cashew_cookies_10rs.png',
    price: 9.09,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Marie Gold 250gm Rs 28 ',
    id: '251',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 10.732408,
        mrp: 27,
        price: 24.10225,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 27,
    name: 'Marie Gold 250gm, Rs.28/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/marie_gold_27rs.png',
    price: 24.6,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Marie Gold 52gm Rs 5 ',
    id: '252',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 9.2,
        mrp: 5,
        price: 4.54,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 5,
    name: 'Marie Gold 52gm, Rs.5/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/marie_gold_5rs.png',
    price: 4.54,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Marie Gold 89gm Rs 10 ',
    id: '253',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 10.1,
        mrp: 10,
        price: 8.99,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 10,
    name: 'Marie Gold 89gm, Rs.10/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/marie_gold_10rs.png',
    price: 8.95,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Nutri Choice Digestive 100gm Rs 20 ',
    id: '254',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 9.6,
        mrp: 20,
        price: 18.08,
        vat: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 20,
    name: 'Nutri Choice Digestive 100gm, Rs.20/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/Nutrichoice_digestive.png',
    price: 18.2,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
  {
    brandId: '1',
    companyId: '470042',
    description: 'Vita Marie Gold 150gm Rs 20 ',
    id: '269',
    inventory: [
      {
        allowOrderWithoutInventory: 0,
        availableInventory: 1000,
        marginPercent: 9,
        mrp: 20,
        price: 18.2,
        vat: 14.5,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'Inventory',
      },
    ],
    mrp: 20,
    name: 'Vita Marie Gold 150gm, Rs.20/-',
    pictureUrl:
      'https://bizomdesigners.s3.amazonaws.com/Arpita/projects/2015/Bizom/mobile/Retailer/product%20images/britannia_edited/vita_gold_20rs.png',
    price: 18.18,
    schemesForOutlet: [],
    size: '',
    unit: '',
    unitsPerCase: '1',
    __typename: 'SkunitProperty',
  },
];

export default mock;
